import { useState, useEffect } from 'react';
import { isPlatformNodeJS, throttleToAnimationFrame } from '@utils/common';
import { getUserareaWrapper } from '../utils/getUserareaWrapper.js';

let currentUserareaMaxHeight;
let observer;

/**
 * Hook that always returns the maximum height of the user-area, by calculating
 * the computed max height on every resize.
 */
function useUserareaMaxHeight(ref) {
  const [height, setHeight] = useState(ref.current ? getUserareaMaxHeight(getUserareaWrapper(ref.current)) : 0);
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const userArea = getUserareaWrapper(ref.current);
    const updateMaxHeight = throttleToAnimationFrame(() => {
      setHeight(getUserareaMaxHeight(userArea));
    });
    updateMaxHeight();
    window.addEventListener("resize", updateMaxHeight);
    window.addEventListener("orientationchange", updateMaxHeight);
    return () => {
      window.removeEventListener("resize", updateMaxHeight);
      window.removeEventListener("orientationchange", updateMaxHeight);
    };
  }, [ref]);
  return height;
}
function getUserareaMaxHeight(explicitUserArea) {
  if (isPlatformNodeJS()) {
    return 0;
  }
  const userArea = explicitUserArea ?? getUserareaWrapper();
  if (!observer) {
    observer = new ResizeObserver(() => {
      currentUserareaMaxHeight = Number(window.getComputedStyle(userArea).maxHeight.replace("px", ""));
    });
  }
  if (typeof currentUserareaMaxHeight === "undefined") {
    currentUserareaMaxHeight = Number(window.getComputedStyle(userArea).maxHeight.replace("px", ""));
  }
  return currentUserareaMaxHeight;
}

export { getUserareaMaxHeight, useUserareaMaxHeight };
//# sourceMappingURL=useUserareaMaxHeight.js.map
